const bank = process.env.BANK

const componentConfig = {
  companyData: {
    /*
      component: CompanyData.jsx
      route: /profile/company-data
    */
    amlEntryPoint: {
      isVisible: () => {
        const supportedBanks = ['NEXIBUSINESS']
        return supportedBanks.includes(bank)
      }
    },
    pciEntryPoint: {
      isVisible: () => {
        const supportedBanks = ['NEXIBUSINESS', 'UCI']
        return supportedBanks.includes(bank)
      }
    },
    helpBox: {
      isVisible: () => {
        const supportedBanks = ['NEXIBUSINESS']
        return supportedBanks.includes(bank)
      }
    },
    exchangeRates: {
      isVisible: () => {
        const supportedBanks = ['NEXIBUSINESS']
        return supportedBanks.includes(bank)
      }
    },
    terminalActivation: {
      isVisible: () => {
        const supportedBanks = ['NEXIBUSINESS']
        return supportedBanks.includes(bank)
      }
    },
    pivaFiscalcodeLabel: {
      isVisible: () => {
        const supportedBanks = ['UCI']
        return supportedBanks.includes(bank)
      }
    }
  },
  companyDataDetail: {
    /*
      component: CompanyDataDetail.jsx
      route: /profile/company-data/detail
    */
    editLink: {
      isVisible: () => {
        const supportedBanks = ['NEXIBUSINESS']
        return supportedBanks.includes(bank)
      }
    },
    labelsByShopSourceType: {
      isVisible: () => {
        const supportedBanks = ['NEXIBUSINESS']
        return supportedBanks.includes(bank)
      }
    },
    guaranteeInstruments: {
      isVisible: () => {
        const supportedBanks = ['NEXIBUSINESS']
        return supportedBanks.includes(bank)
      }
    },
    terminalList: {
      isStatusFilterVisible: () => {
        const supportedBanks = ['NEXIBUSINESS']
        return supportedBanks.includes(bank)
      },
      tableStatusColumnsVisible: () => {
        const supportedBanks = ['NEXIBUSINESS']
        return supportedBanks.includes(bank)
      },
      disactivateTerminalFunctionality: () => {
        const supportedBanks = ['NEXIBUSINESS']
        return supportedBanks.includes(bank)
      }
    },
    detailTerminal: {
      isStatusTerminalVisible: () => {
        const supportedBanks = ['NEXIBUSINESS']
        return supportedBanks.includes(bank)
      },
      isTerminalActivationDateVisible: () => {
        const supportedBanks = ['NEXIBUSINESS']
        return supportedBanks.includes(bank)
      }
    }
  }
}

export default componentConfig
